<script>
import { Line } from 'vue-chartjs'

export default {
  extends: Line,
  props: {
    /**
     * Chart series
     * @object
     */
    chartdata: {
      type: Object,
      default: null
    },
    /**
     * Chart options
     * @object
     */
    options: {
      type: Object,
      default: null
    }
  },
  mounted () {
    this.renderChart(this.chartdata, this.options)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/line-chart.vue